module.exports = __webpack_public_path__ + "img/logo.8cc3cbc0.png";